import { Type } from 'class-transformer';
import { UnsplashUserLinks } from './unsplash-links';

export class UnsplashUser {
  name: string;

  @Type(() => UnsplashUserLinks)
  links: UnsplashUserLinks;
}
